import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AddOrEditTaskPage from './AddOrEditTaskPage'
import {
	readTask,
	receiveTask,
	handleFieldChange,
	changeAutomationType,
	selectCampaign,
	selectStage,
	listTaskTypes,
	handleCalendarChange,
} from '../../actions/tasks'
import { getContactsWithEmails } from '../../actions/contacts'
import { getAllGroups } from '../../actions/contacts/groups'
import { listTemplates, readFooter } from '../../actions/template'
import { list, read } from 'actions/data'
import { withStyles } from '@material-ui/core'
import { stepperGoTo } from 'actions/view'

const styles = (theme) => ({
	// ...other styles for the pages
	content: {
		padding: 24,
		height: '100%',
		overflowY: 'auto',
		[theme.breakpoints.down('sm')]: {
			padding: 0,
			height: '100%',
			overflowX: 'hidden',
		},
		[theme.breakpoints.down('xs')]: {
			padding: 0,
		},
	},
	contentModal: {
		padding: 24,
		height: 'calc(100% - 60px)',
		marginTop: 60,
		overflowY: 'hidden',
		[theme.breakpoints.down('sm')]: {
			padding: 0,
			overflowX: 'hidden',
			// height: 'calc(100% - 54px)',
		},
		[theme.breakpoints.down('xs')]: {
			padding: 0,
		},
	},
})

export default connect(
	(state, { match, taskID }) => ({
		task: state.tasks.tasksByID[taskID || match.params.taskID] || null,
		taskID: taskID || match.params.taskID,
		templateLoadStatus: state.loadStatus.templatesById,
		contactLoadStatus: state.loadStatus.contacts,
		groupLoadStatus: state.loadStatus.groups,
		taskTypeLoadStatus: state.loadStatus.taskTypes,
		campaignLoadStatus: state.loadStatus.campaigns,
		phonenumbersLoadStatus: state.loadStatus.phonenumbers,
		// selectedActionPrediction:
		// 	state.tasks.addOrEdit.fields.selectedActionPrediction.value,
	}),
	(dispatch) =>
		bindActionCreators(
			{
				readTask,
				receiveTask,
				getContactsWithEmails,
				getAllGroups,
				listTemplates,
				readFooter,
				handleFieldChange,
				changeAutomationType,
				selectCampaign,
				selectStage,
				listTaskTypes,
				handleCalendarChange,
				list,
				read,
				stepperGoTo,
			},
			dispatch,
		),
)(withStyles(styles)(AddOrEditTaskPage))
